import React from 'react';
import { useSnackbar } from 'notistack';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';

const SnackBarCustom = (props) => {
    const { tipo, mensaje, aceptar } = props;
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    function close(key) {
        if (aceptar) {
            aceptar();
        };
        closeSnackbar(key);
    };
    return (
        <div style={{display:"none"}}>
            {
                enqueueSnackbar(mensaje, {
                    variant: tipo,
                    preventDuplicate: true,
                    autoHideDuration: aceptar ? 10000 : 4000,
                    onClose: aceptar ? aceptar : null,
                    action: key => (
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={() => close(key)} >
                            {aceptar ?
                                <CheckIcon />
                                :
                                <CloseIcon />
                            }
                        </IconButton>
                    )
                    ,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'right',
                    }
                })
            }
        </div>
    )
}

export default SnackBarCustom;
    //const Icon = variantIcon[tipo];
    //import clsx from 'clsx';
//import { Snackbar, SnackbarContent } from '@material-ui/core';
/*
const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { amber, green } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

const useStyles1 = makeStyles(theme => ({
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.main,
    },
    warning: {
        backgroundColor: amber[700],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
}));
    //const [verSnack, setVerSnack] = useState(true);
    const classes = useStyles1();
    //className:clsx(classes[tipo]),

function cerrarSnack(event, reason) {
        if (reason === 'clickaway') {
            return;
        };
        if (aceptar) {
            aceptar();
        };
        setVerSnack(false);
    };

<Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                open={verSnack}
                autoHideDuration={aceptar ? 6000 : 4000}
                onClose={cerrarSnack}
            >
                <SnackbarContent
                    className={clsx(classes[tipo])}
                    aria-describedby="client-snackbar"
                    message={
                        <span id="client-snackbar" className={classes.message}>
                            <Icon className={clsx(classes.icon, classes.iconVariant)} />
                            {mensaje}
                        </span>
                    }
                    action={[
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={cerrarSnack}>
                            {aceptar ?
                                <CheckIcon className={classes.icon} />
                                :
                                <CloseIcon className={classes.icon} />
                            }
                        </IconButton>
                        ,
                    ]}
                />
            </Snackbar>
*/